import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = {
  obtenerPedido() {
    var url = ConfigAPI.baseURL + "orders" + Session.getToken();
    return instance.get(url);
  },
  mostrarPedido(id) {
    var url = ConfigAPI.baseURL + "orders/" + id + Session.getToken();
    return instance.get(url);
  },
  agregarPedido(data) {    
    var params = data
    var url = ConfigAPI.baseURL + "orders" + Session.getToken();
    return instance.post(url,params);
  },
  editarPedido(data) {    
    var params = data    
    var url = ConfigAPI.baseURL + "orders/"+ data.id + Session.getToken();
    return instance.post(url,params);
  },
  eliminarPedido(id) {
    var url = ConfigAPI.baseURL + "orders/"+ id + Session.getToken();
    return instance.delete(url);
  }, 
  filtrarPedido(data, page) {
    var params = data    
    var url = ConfigAPI.baseURL + "orders/filter/query" + Session.getToken() + "&page=" + page;
    return instance.post(url,params);
  },  
  cambiarEstadoPedido(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "orders/change/status" + Session.getToken();
    return instance.post(url,params);
  },
  cambiarPago(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "orders/change/paid" + Session.getToken();
    return instance.post(url,params);    
  },
  getLinkPago(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "orders/get/link" + Session.getToken();
    return instance.post(url,params);    
  },
  trackingPedido(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "orders/change/status/in_transport" + Session.getToken();
    return instance.post(url,params);        
  },
  changeNroOrderInternal(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "orders/change/nro_order_internal" + Session.getToken();
    return instance.post(url,params);    
  },
  changeNameProduct(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "ordersDetail/" + data.id + Session.getToken();
    return instance.post(url,params);    
  },
  sendEmailOrder(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "orders/send/email" + Session.getToken();
    return instance.post(url,params);    
  },  
  obtenerClientesByZonas(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "sellers/filter/customerByZone" + Session.getToken();
    return instance.post(url,params);     
  },

  obtenerConfiguracion() {
    var url = ConfigAPI.baseURL + "orders-configuration" + Session.getToken();
    return instance.get(url);
  },
  saveConfiguracion(data) {
    var params = data
    var url = ConfigAPI.baseURL + "orders-configuration/" + data.id + Session.getToken();
    return instance.post(url,params);
  },  

  obtenerClientes() {
    var url = ConfigAPI.baseURL + "customers" + Session.getToken();
    return instance.get(url);
  },
  buscarClientesPorNombre(name, sellers_id) {
    var url = ConfigAPI.baseURL + "customers/filter/name" + Session.getToken();
    return instance.post(url, { name, sellers_id });
  },
  mostrarCliente(id) {
    var url = ConfigAPI.baseURL + "customers/" + id + Session.getToken();
    return instance.get(url);
  },
  obtenerVendedores() {
    var url = ConfigAPI.baseURL + "sellers" + Session.getToken();
    return instance.get(url);
  },
  obtenerZonas() {
    var url = ConfigAPI.baseURL + "sellers-zone" + Session.getToken();
    return instance.get(url);
  },
  buscarZonasPorNombre(name) {
    var url = ConfigAPI.baseURL + "sellers-zone/filter/query" + Session.getToken();
    return instance.post(url, { name });
  },
  obtenerZonasPorVendedor(sellers_id) {
    var url = ConfigAPI.baseURL + "sellers/filter/zonesBySeller" + Session.getToken();
    return instance.post(url, { sellers_id });
  },
  obtenerPuntosVentas() {
    var url = ConfigAPI.baseURL + "sales-points-sales" + Session.getToken();
    return instance.get(url);
  },    
  
  integratedManufactureSystemPedido(data) {
    var params = data.data
    var url = data.url;
    return instance.post(url,params);
  },
  cambiarEstadoPedidoEnPreparacion(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "orders/change/status/in_preparation" + Session.getToken();
    return instance.post(url,params);        
  },
  cambiarEstadoSistemaProduccion(data) {
    var params = data    
    var url = ConfigAPI.baseURL + "orders/change/statusSystemManufacture" + Session.getToken();
    return instance.post(url,params);        
  },  


  obtenerGruposClientes() {
    var url = ConfigAPI.baseURL + "customers-groups" + Session.getToken();
    return instance.get(url);
  },

  obtenerMotivos() {
    var url = ConfigAPI.baseURL + "orders-reason" + Session.getToken();
    return instance.get(url);
  },

  obtenerReglasApi() {
    var url = ConfigAPI.baseURL + "orders-api-rules" + Session.getToken();
    return instance.get(url);
  },
  agregarReglaApi(data) {
    var url = ConfigAPI.baseURL + "orders-api-rules" + Session.getToken();
    return instance.post(url, data);
  },
  editarReglaApi(data) {
    var url = ConfigAPI.baseURL + "orders-api-rules/" + data.id + Session.getToken();
    return instance.post(url, data);
  },
  eliminarReglaApi(id) {
    var url = ConfigAPI.baseURL + "orders-api-rules/" + id + Session.getToken();
    return instance.delete(url);
  },
  mostrarMotivos(id) {
    var url = ConfigAPI.baseURL + "orders-reason/" + id + Session.getToken();
    return instance.get(url);
  },
  agregarMotivos(data) {    
    var params = data
    var url = ConfigAPI.baseURL + "orders-reason" + Session.getToken();
    return instance.post(url,params);
  },
  editarMotivos(data) {    
    var params = data    
    var url = ConfigAPI.baseURL + "orders-reason/"+ data.id + Session.getToken();
    return instance.post(url,params);
  },
  eliminarMotivos(id) {
    var url = ConfigAPI.baseURL + "orders-reason/"+ id + Session.getToken();
    return instance.delete(url);
  }, 
  filtrarMotivos(data, page) {
    var params = data
    var url = ConfigAPI.baseURL + "orders-reason/filter/query" + Session.getToken() + "&page=" + page;
    return instance.post(url,params);
  },

  obtenerClientesPorMotivo(reasonID) {
    var url = ConfigAPI.baseURL + "orders-reason-customers/by-reason/" + reasonID + Session.getToken();
    return instance.get(url);
  },
  guardarClientesPorMotivo(data) {
    var params = data
    var url = ConfigAPI.baseURL + "orders-reason-customers/by-reason" + Session.getToken();
    return instance.post(url, params);
  },
  obtenerEventosDisponibles(reasonID, customersID, date, includeID) {
    var url = ConfigAPI.baseURL + "orders-reason-events/available" + Session.getToken() +
              "&reason_id=" + reasonID + "&customers_id=" + customersID + "&date=" + (date || '') +
              (includeID ? "&include_id=" + includeID : "");
    return instance.get(url);
  },
  obtenerTodosLosEventos() {
    var url = ConfigAPI.baseURL + "orders-reason-events" + Session.getToken() + "&all=1";
    return instance.get(url);
  },
  obtenerEventosPorMotivo(reasonID) {
    var url = ConfigAPI.baseURL + "orders-reason-events" + Session.getToken() + "&reason_id=" + reasonID;
    return instance.get(url);
  },
  agregarEvento(data) {
    var url = ConfigAPI.baseURL + "orders-reason-events" + Session.getToken();
    return instance.post(url, data);
  },
  editarEvento(data) {
    var url = ConfigAPI.baseURL + "orders-reason-events/" + data.id + Session.getToken();
    return instance.post(url, data);
  },
  eliminarEvento(id) {
    var url = ConfigAPI.baseURL + "orders-reason-events/" + id + Session.getToken();
    return instance.delete(url);
  },
  obtenerClientesPorEvento(eventID) {
    var url = ConfigAPI.baseURL + "orders-reason-events/" + eventID + "/customers" + Session.getToken();
    return instance.get(url);
  },
  obtenerClientesPorGrupo(groupID) {
    var url = ConfigAPI.baseURL + "customers-groups/" + groupID + "/customers" + Session.getToken();
    return instance.get(url);
  },
  guardarClientesPorEvento(eventID, customers) {
    var url = ConfigAPI.baseURL + "orders-reason-events/" + eventID + "/customers" + Session.getToken();
    return instance.post(url, { customers: customers });
  },

  eliminarAdjunto(id) {
    var url = ConfigAPI.baseURL + "orders-attach/"+ id + Session.getToken();
    return instance.delete(url);
  },

  obtenerStockRerserved() {
    var url = ConfigAPI.baseURL + "orders-reason-products" + Session.getToken();
    return instance.get(url);
  },
  mostrarStockRerserved(id) {
    var url = ConfigAPI.baseURL + "orders-reason-products/" + id + Session.getToken();
    return instance.get(url);
  },
  agregarStockRerserved(data) {    
    var params = data
    var url = ConfigAPI.baseURL + "orders-reason-products" + Session.getToken();
    return instance.post(url,params);
  },
  editarStockRerserved(data) {    
    var params = data    
    var url = ConfigAPI.baseURL + "orders-reason-products/"+ data.id + Session.getToken();
    return instance.post(url,params);
  },
  eliminarStockRerserved(id) {
    var url = ConfigAPI.baseURL + "orders-reason-products/"+ id + Session.getToken();
    return instance.delete(url);
  }, 
  filtrarStockRerserved(data, page) {
    var params = data    
    var url = ConfigAPI.baseURL + "orders-reason-products/filter/query" + Session.getToken() + "&page=" + page;
    return instance.post(url,params);
  },       
}

export default servicesAPI;
